import SweepInstructionsList from './SweepInstructionsList';
export default SweepInstructionsList;



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/SweepInstructionsList/index.js